import React from "react";
import { Box } from "@mui/material";
import Label from "../Label/Label";
import {
  PARTIAL_BATCH_MISSING_VALUE_COLORS,
  PARTIAL_BATCH_MISSING_VALUE_NOTE,
} from "../../constants/analyticsBatches";

const PartialBatchMissingValueNote = () => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      gap: 1,
      px: 1,
      py: 0.5,
    }}
  >
    <Box
      aria-hidden="true"
      sx={{
        width: 14,
        height: 14,
        flexShrink: 0,
        borderRadius: "3px",
        border: `1px solid ${PARTIAL_BATCH_MISSING_VALUE_COLORS.border}`,
        backgroundColor: PARTIAL_BATCH_MISSING_VALUE_COLORS.background,
      }}
    />
    <Label
      text={PARTIAL_BATCH_MISSING_VALUE_NOTE}
      fontSize="12px"
      color={PARTIAL_BATCH_MISSING_VALUE_COLORS.text}
    />
  </Box>
);

export default PartialBatchMissingValueNote;
